import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { addSection, getAllPageSections } from "store/actions";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import ReactSelect from "react-select";

const AddElevator = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    loading,
    error,
    sections: categories,
  } = useSelector((state) => state.section);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  // effects
  useEffect(() => {
    dispatch(getAllPageSections("elevatorsCategories"));
  }, [dispatch]);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = selectedImage?.path;
    data.title = data?.heading?.en;

    dispatch(
      addSection({ page: "elevators", data: { section: data }, navigate })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addItem"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Row>
                  <Col lg={8} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"item"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                        accept="image/*, video/*"
                        className="w-auto"
                      />
                    </div>
                  </Col>
                  <Row />
                  <Col>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id="category" />
                      </h5>

                      <Controller
                        control={control}
                        name="category"
                        rules={{ required: true }}
                        render={({ field: { onChange, value, name, ref } }) => (
                          <ReactSelect
                            inputRef={ref}
                            name={name}
                            placeholder={<FormattedMessage id={"category"} />}
                            options={categories?.map((c) => ({
                              value: c?.slug,
                              label: c?.heading?.[locale],
                            }))}
                            onChange={(selectedOption) => {
                              onChange(selectedOption.value);
                            }}
                            isRtl={true}
                            isSearchable={false}
                            className="basic-single"
                            classNamePrefix="select"
                          />
                        )}
                      />
                    </div>
                  </Col>
                </Row>

                <AddButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddElevator;
